// @flow
import { Outlet } from 'react-router';

const FarmerApp = (): React$Node => {
  return <Outlet />;
};

export default FarmerApp;
